const DISTRICT_ADMIN_PERMISSION = "admin_test_prep_settings_district";
const SCHOOL_ADMIN_PERMISSION = "admin_test_prep_settings";

export interface User {
    firstName: string;
    lastName: string;
    userId: string;
    tenantId: string;
    permissions: string[];
    districtUser: boolean;
    preferences: {
        testprepWelcomeModal?: boolean;
    };
}

export class CurrentUser implements User {
    lastName: string;
    userId: string;
    tenantId: string;
    permissions: string[];
    firstName: string;
    districtUser: boolean;
    preferences: {
        testprepWelcomeModal?: boolean;
    };

    constructor(user: User) {
        this.lastName = user.lastName;
        this.userId = user.userId;
        this.tenantId = user.tenantId;
        this.permissions = user.permissions;
        this.firstName = user.firstName;
        this.districtUser = user.districtUser;
        this.preferences = user.preferences;
    }

    hasPermission(permission: string): boolean {
        return this.permissions.some((permItem) => permItem === permission);
    }

    isSchoolAdmin(): boolean { return this.hasPermission(SCHOOL_ADMIN_PERMISSION); }
    
    isDistrictAdmin(): boolean { return this.hasPermission(DISTRICT_ADMIN_PERMISSION); }

    isAdmin(): boolean { return this.isSchoolAdmin() || this.isDistrictAdmin(); }
}


/** WEBPACK FOOTER **
 ** ./~/tslint-loader!./app/models/user/user.model.ts
 **/